import React, { useContext, useGlobal } from "reactn";
import PropTypes from "prop-types";

// styles
import { HeaderWrapper, HeaderInner, HeaderCloseButton, HeaderCloseButtonText, HeaderCloseIcon } from "./Header.styled";

import { StoreLocatorContext } from "../../../context/Context";
import DetectDeviceResize from "shared-anpost-components/hooks/detectDeviceResizeHook";

import { allowZooomAndScroll } from "../../../helpers/Helpers";
import Icon from "../icons/ReturnIcons";

export const Header = ({ children, isMobileApp }) => {
	const { setInitStoreLocator, setParamsRecord, setExitApp } = useContext(StoreLocatorContext);
	const [isCollectionPointFinderActive, setIsCollectionPointFinderActive] = useGlobal("isCollectionPointFinderActive");
    const [isParcelLockerFinderActive, setIsParcelLockerFinderActive] = useGlobal("isParcelLockerFinderActive");

	const { isMobile } = DetectDeviceResize();

	// close store locator on AP
	const hideStoreLocator = () => {
		// reset the record when closing the map
		setParamsRecord({});

		// hide the map
		setInitStoreLocator(false);

		// set a value for exiting the store locator
		setExitApp(true);

		// when closing the app remove event listener preventing zoom
		allowZooomAndScroll();

		// resetting the hash value in the url when closing the app
		setIsParcelLockerFinderActive(false)
		setIsCollectionPointFinderActive(false)
	};



	return (
		<HeaderWrapper isMobileApp={isMobileApp}>
			<HeaderInner className={isMobile ? "isMobile" : ""}>
				<div style={{cursor: "pointer"}} onClick={hideStoreLocator}><Icon src="leftArrowIcon" /></div>
				{isMobile ? <p className="backParagraph">Back</p> :<div>{children}</div>}
			</HeaderInner>
		</HeaderWrapper>
	);
};

Header.propTypes = {
	children: PropTypes.object,
	isMobileApp: PropTypes.bool
};
